import React from "react";

// components
import Navbar from "components/Navbars/AuthNavbar.js";
import MiniLogin from "components/Login/MiniLogin";

export default function LoginPage() {

    return (
        <>
            <Navbar transparent />
            <main>
                <div className="relative pt-20 pb-6 flex content-center items-center justify-center min-h-screen h-full">
                    <div
                        className="absolute top-0 w-full h-full bg-center bg-cover bg-blueGray-100 z-0"
                    >
                    </div>
                    <div className="flex flex-col container content-center items-center justify-center w-full h-full z-10">
                        <MiniLogin title={'Inicia sesión'} />
                    </div>
                </div>
            </main>
        </>
    );
}